 
 
import "../navigation/navigation.tsx";
export default class Header extends HTMLElement {
  connectedCallback() {
    this.render();
  }
  render() {
        this.innerHTML = `<header class="header-SIQxI6oN-container">
        <div class="header-SIQxI6oN-innerContainer">
          <h1 class="header-SIQxI6oN-logo">
            <a title="Home Page" href="/">
              Analog Studios
            </a>
          </h1>
          <as-navigation></as-navigation>
        </div>
      </header>`;

  }
}
customElements.define("as-header", Header);
